var AppDispatcher = require('../core/AppDispatcher.jsx');
var ActionTypes = require('../constants/SelectCustomerConstants.js').ActionTypes;
 
module.exports = {
    updateClientOin:function(clientOin) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_CLIENT_OIN,
            clientOin: clientOin
        })
    },

    setClientOin:function(clientOin) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_CLIENT_OIN,
            clientOin: clientOin
        })
    },

    forwardFromClientOin:function() {
        AppDispatcher.dispatch({
            actionType: ActionTypes.FORWARD_FROM_CLIENT_OIN
        })
    },

    clientOinUpdated:function(clientOin) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLIENT_OIN_UPDATED,
            clientOin: clientOin
        })
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/ClientOinActions.js